import { createAsyncThunk } from "@reduxjs/toolkit";
import { trackPromise } from "react-promise-tracker";
import { fetchWrapper } from "_utils";
import { blobBrowserDownload } from "_utils/files/blobBrowserDownload";

const baseUrl = `${process.env.REACT_APP_MARKETER_API_URL}/api`;

/** Helper */
const apiCall = async (promise, rejectWithValue, validate = false) => {
  try {
    const response = await trackPromise(promise);
    if (validate) {
      const { Succeeded, Errors, Message } = response;
      if (!Succeeded && Errors?.length) throw new Error(Message);
    }
    return response;
  } catch (error) {
    return rejectWithValue(error);
  }
};

export const getBalancingCurtailmentAndGroupApi = createAsyncThunk(
  "drvForecast/getBalancingCurtailmentAndGroupApi",
  async (_, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.get(`${baseUrl}/balancing-curtailment-and-group`),
      rejectWithValue
    )
);

export const getDrvForecastAttachmentsApi = createAsyncThunk(
  "drvForecast/getDrvForecastAttachmentsApi",
  async (_, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.get(`${baseUrl}/drv-forecast/attachments`),
      rejectWithValue
    )
);

export const postDrvForecastViewApi = createAsyncThunk(
  "drvForecast/postDrvForecastViewApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/drv-forecast/view`, { Data: payload }),
      rejectWithValue,
      true
    )
);

export const postDrvForecastViewForecastApi = createAsyncThunk(
  "drvForecast/postDrvForecastViewForecastApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/drv-forecast/view-forecast`, { Data: payload }),
      rejectWithValue,
      true
    )
);

export const postDrvForecastUploadAttachmentsApi = createAsyncThunk(
  "drvForecast/postDrvForecastUploadAttachmentsApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/drv-forecast/upload-attachments`, {
        Data: payload,
      }),
      rejectWithValue,
      true
    )
);

export const postDrvForecastSaveApi = createAsyncThunk(
  "drvForecast/postDrvForecastSaveApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/drv-forecast/save`, {
        Data: payload,
      }),
      rejectWithValue,
      true
    )
);

export const postDrvForecastSendApi = createAsyncThunk(
  "drvForecast/postDrvForecastSendApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.post(`${baseUrl}/drv-forecast/send`, {
        Data: payload,
      }),
      rejectWithValue,
      true
    )
);

export const deleteDrvForecastAttachmentsApi = createAsyncThunk(
  "drvForecast/deleteDrvForecastAttachmentsApi",
  async (payload, { rejectWithValue }) =>
    apiCall(
      fetchWrapper.delete(`${baseUrl}/drv-forecast/delete-attachments`, {
        Data: payload,
      }),
      rejectWithValue,
      true
    )
);

export const getDrvForecastDownloadFileApi = createAsyncThunk(
  "drvForecast/getDrvForecastDownloadFileApi",
  async (fileName, { rejectWithValue }) => {
    try {
      const { blob, headers } = await fetchWrapper.getFile(
        `${baseUrl}/drv-forecast/download-file?filename=${encodeURIComponent(fileName)}`
      );
      blobBrowserDownload(blob, headers, fileName);
      return true;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);